module.exports = __webpack_public_path__ + "static/media/icon-profile-edit.a677c26d.svg";